export const DEFAULT_TIMEOUT_TO_OPEN_MODAL = 30_000
